<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：产品码-产品码列表
      -->
  <div class="user">

    <!--添加产品码-->
    <div class="common-level-rail" style="float: right;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/productcode/add'">添加产品码</el-button>
      
    </div>
    
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="产品id：" prop="product_id">
          <el-input v-model="formInline.product_id" placeholder="请填写产品id"></el-input>
        </el-form-item>
        <el-form-item label="批次：" prop="batch">
          <el-input v-model="formInline.batch"  placeholder="请输入批次"></el-input>
        </el-form-item>
        <el-form-item label="是否导出">
          <el-select v-model="formInline.is_export" placeholder="是否导出">
          <el-option label="请选择" value=""></el-option>
            <el-option label="未导出" value="0"></el-option>
            <el-option label="已导出" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item></el-form-item>
      </el-form>
      <div class="red">本产品码仅适用于小程序场景，使用时须在小程序后台设置  普通链接二维码规则 {{url}} ，小程序跳转路径为：packageA/pcode/pcode</div>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="batch" label="批次"></el-table-column>
          <el-table-column prop="product_id" label="产品id"></el-table-column>
          <el-table-column prop="product.product_name" label="产品名称"></el-table-column>
          <el-table-column prop="machine_code" label="设备编码"></el-table-column>
          <el-table-column prop="use_time" label="时长(分钟)"></el-table-column>
          <el-table-column prop="code_num" label="产品码数量"></el-table-column>
          <el-table-column prop="is_export" label="是否导出" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_export == 0" class="green">未导出</span>
              <span v-if="scope.row.is_export == 1" class="green">已导出</span>
            </template>
          </el-table-column>
          <el-table-column prop="export_time" label="导出时间" width="180">

          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/product/productcode/detail'">详情</el-button>
              <el-button  type="text" size="small" @click="onExport(scope.row)" v-auth="'/product/productcode/export'">导出</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      url:window.location.protocol + '//' + window.location.host+'/pcode?code=',
      /*横向表单数据模型*/
      formInline: {
        product_name: '',
        batch: '',
        is_export:'',
      },
      /*是否打开添加弹窗*/
      open_add: false,
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      ProductApi.ProductCodelist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },

    /*导出数据*/
    onExport(row) {


      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/product.productCode/export?batch='+row.batch;

    },


    /*打开添加*/
    addClick() {
      this.$router.push('/product/productcode/add');
    },


    /*打开详情*/
    detailClick(row) {
      this.$router.push({
        path: '/product/productcode/detail',
        query: {
          batch: row.batch,

        }
      });
    },

  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/product/productcode/index.vue